import axios from 'axios';

import ApiBase from './ApiBase';

export const externalAPI = axios.create();

export default ApiBase;
